import React from "react";
import { Route, Routes } from "react-router-dom";
import AllProgramsPage from "./programs.all";
import AddProgramPage from "./program.add";
import ProgramDetailsPage from "./programs.details";
import EditProgramPage from "./program.edit";

const Programs = () => {
  return (
    <Routes>
      <Route element={<ProgramDetailsPage />} path=":serviceId/details" />

      <Route element={<EditProgramPage />} path=":serviceId/edit" />

      <Route element={<AddProgramPage />} path="add" />

      <Route element={<AllProgramsPage />} path="" />

      {/* <Route element={<AllProgramsPage />} path="/dashboard/organization/:id" /> */}
    </Routes>
  );
};

export default Programs;
